import { Icon } from '@oneaudi/unified-web-components';
import React, { useContext, type FC } from 'react';
import styled from 'styled-components';
import { UniversalStateContext } from '../../context/UniversalStateContext';

type Direction = 'back' | 'forward';

const StyledArrowButton = styled.button<{ direction: Direction }>`
  position: absolute;
  top: -2px;
  background-color: ${({ theme }) =>
    process.env.IS_LEGACY
      ? theme.colors.globalColorElevationLevel4
      : theme.colors.sysColorSurfaceNeutral800};

  backdrop-filter: blur(5px);
  border: none;
  border-radius: 50%;
  padding: 10px;
  margin: 8px 8px;
  transform: ${({ direction }) => (direction === 'back' ? 'rotate(90deg)' : 'rotate(-90deg)')};
  pointer-events: auto;
  display: none;
  @media (min-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: block;
  }
  &:not(:disabled):hover {
    cursor: pointer;
  }
  & > svg {
    color: ${({ theme, disabled }) =>
      disabled
        ? theme.colors.sysColorSurfaceNeutral400
        : theme.colors.semColorActionPrimaryForegroundIconDefault};
    display: block;
  }
`;

export interface ArrowButtonProps {
  readonly onClick: () => void;
  readonly direction: Direction;
  readonly disabled?: boolean;
}

export const ArrowButton: FC<ArrowButtonProps> = ({ onClick, direction, disabled = false }) => {
  const { i18nTexts } = useContext(UniversalStateContext)!;

  return (
    <StyledArrowButton
      onClick={onClick}
      disabled={disabled}
      direction={direction}
      aria-label={direction === 'back' ? i18nTexts.previousButtonText : i18nTexts.nextButtonText}
    >
      <Icon name="arrow-down" size="xs" />
    </StyledArrowButton>
  );
};
